import { render } from "./진료예약(안내)-main.vue?vue&type=template&id=55128fd6"
import script from "./진료예약(안내)-main.vue?vue&type=script&lang=js"
export * from "./진료예약(안내)-main.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__